import Icon from '../../components/Icon.vue'

Icon.register({"brands/gg-circle":{"width":512,"height":512,"paths":[{"d":"M257 8C120 8 9 119 9 256S120 504 257 504 505 393 505 256 394 8 257 8zM207.5 382.8L81.8 257.1 207.5 131.4 242.7 166.8 218.5 191 207.4 179.9 130.2 257.1 207.4 334.3 234 307.7 180.9 254.8 205.3 230.4 282.5 307.6 207.5 382.8zM306.5 380.6L271.3 345.4 295.4 321 306.5 332.1 383.7 254.9 306.5 177.7 280 204.2 333.1 257.1 308.7 281.5 231.5 204.3 306.5 129.3 432.2 255 306.5 380.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/gg-circle.js
// module id = AE1b
// module chunks = 0